import * as navigation from 'Navigation';

export default class PlateDesignTemplateTabState extends navigation.TabState {
  override defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Plate Design Template',
      closeable: false,
      preferenceKey: 'plate-design-template',
    };
  }
}
